import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

export type AlertType = 'success' | 'error' | 'info' | 'warning';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss'],
  standalone: false
})
export class AlertModalComponent implements OnInit {
  @Input() type: AlertType = 'error';
  @Input() message: string = '';
  @Input() title: string = '';
  @Output() closed = new EventEmitter<void>();

  iconMap = {
    success: 'checkmark-circle',
    error: 'warning',
    info: 'information-circle',
    warning: 'alert-circle'
  };

  constructor(private popoverController: PopoverController) { }

  ngOnInit(): void {
  }

  @Input() showCancel = false;

  onClose(): void {
    this.closed.emit();
    this.popoverController.dismiss({ result: true });
  }

  onCancel(): void {
    this.popoverController.dismiss({ result: false });
  }

  getIconName(): string {
    return this.iconMap[this.type];
  }
}
